import { Injectable } from 'angular2/core';
import { Response, URLSearchParams, RequestOptionsArgs } from 'angular2/http';
import { Observable } from 'rxjs/Observable';

import { Resource } from '../api/resource.service';
import { Event } from './event.model';

import { Attendee } from '../attendee/attendee.model';

@Injectable()
export class EventService {

  constructor(private resource: Resource) { }

  save(event: Event): Observable<Response> {
    return this.resource.save(event);
  }

  get(id: string): Observable<Event> {
    return this.resource.get(id).map(response => {
      return Event.fromJSON(response.json());
    });
  }

  delete(event: Event): Observable<Response> {
    return this.resource.delete(event);
  }

  list(): Observable<Response> {
    return this.resource.list();
  }

  listPublic(): Observable<Response> {
    return this.resource.http.noAuth().get('/pub/events');
  }

  bookEvent(data: IBookingData): Observable<Response> {
    return this.resource.http.noAuth().put(
      '/pub/events/' + data.eventId + '/attendees',
      JSON.stringify(data));
  }

  requestEvent(data: IBookingData): Observable<Response> {
    return this.resource.http.noAuth().put(
      '/pub/events/' + data.eventId + '/requesters',
      JSON.stringify(data));
  }

  getAttendees(event: Event): Observable<Attendee[]> {
    return this.getUsers(event, 'attendees');
  }

  getAttendeesPub(event: Event): Observable<Attendee[]> {
    return this.asAttendeeList(
      this.resource.http.noAuth().get('/pub/events/' + event.id + '/attendees'));
  }

  getRequesters(event: Event): Observable<Attendee[]> {
    return this.getUsers(event, 'requesters');
  }

  getUsers(event: Event, type: string): Observable<Attendee[]> {
    return this.asAttendeeList(
      this.resource.http.get('/events/' + event.id + '/' + type));
  }

  private asAttendeeList(obs: Observable<Response>): Observable<Attendee[]> {
    return obs.map(response => {
      let json = response.json();
      if (!(json instanceof Array)) {
        throw 'response must be a JSON Array';
      }
      let atts: Attendee[] = [];
      for (let rawAtt of json) {
        atts.push(Attendee.fromObject(rawAtt));
      }
      return atts;
    });
  }
}

export interface IBookingData {
  eventId: string;
  attendeeId: string;
  companyId: string;
  comments: string;
  asLeader?: boolean;
  vetoedCompanies?: string[];
}



/** WEBPACK FOOTER **
 ** ./~/tslint-loader!./src/event/event.service.ts
 **/